import { Link } from "react-router-dom";
import OptimizedImage from "../OptimizedImage";

const DrGray = () => {
  return (
    <div className="space-y-6">
      <div className="prose prose-lg">
        <h3 className="text-2xl font-serif">Dr. William Allen Gray, MD, DMD, MBA, FACS</h3>
        <p className="text-gray-600">
          With over 18 years of experience in surgery and reconstruction of the face, Dr. Gray leads our practice with expertise and dedication to achieving natural-looking results. His extensive training and commitment to staying current with the latest advancements ensure our patients receive the highest standard of care.
        </p>
        <ul className="list-none space-y-2 text-gray-600">
          <li>• American Society of Hair Restoration Surgery</li>
          <li>• American Academy of Facial Plastic Surgery</li>
          <li>• MD - Oregon Health & Science University School of Medicine</li>
          <li>• DMD - University of Pennsylvania School of Dental Medicine</li>
          <li>• MBA - Northwestern University Kellogg School of Management</li>
        </ul>
      </div>
      <div className="space-y-4">
        <OptimizedImage
          src="/lovable-uploads/504ca7ed-75d2-42d8-8fff-9ab401a18e37.png"
          alt="Dr. Gray"
          className="w-full h-80 object-cover rounded-lg shadow-lg mb-4"
        />
        <div className="grid grid-cols-2 gap-4">
          <OptimizedImage
            src="/lovable-uploads/867722cc-6916-4105-a2d7-41f7231b9869.png"
            alt="Dr. Gray at Evolutions Medspa"
            className="w-full h-48 object-cover rounded-lg shadow-lg"
          />
          <OptimizedImage
            src="/lovable-uploads/4502d381-ac3f-43de-aff7-61e54041ce42.png"
            alt="Dr. Gray in office"
            className="w-full h-48 object-cover rounded-lg shadow-lg"
          />
        </div>
      </div>
    </div>
  );
};

export default DrGray;